// extracted by mini-css-extract-plugin
export default {"navigation_crumb_main_div":"DesignBoxNavigationCrumb_navigation_crumb_main_div__sE-JZ","right_arrow":"DesignBoxNavigationCrumb_right_arrow__Lh5SC"};